import {
  DashboardAdminPermissions,
  DashboardUserPermissions,
  FileTrackerAdminPermissions,
  FileTrackerUserPermissions,
  ProgramUserPermissions,
  ProgramAdminPermissions,
} from './common';

const VerificationsAdminFeaturePermissions = {
  MayViewAdminPage: 'V-MVAP',
};

const VerificationsClientUserPermissions = {
  ...DashboardUserPermissions,
  ...FileTrackerUserPermissions,
  ...ProgramUserPermissions,
};

const VerificationsClientAdminPermissions = {
  ...VerificationsClientUserPermissions,
  ...DashboardAdminPermissions,
  ...FileTrackerAdminPermissions,
  ...ProgramAdminPermissions,
};

const VerificationsAdminPermissions = {
  ...VerificationsClientAdminPermissions,
  ...VerificationsAdminFeaturePermissions,
};

export const verificationsRoles = {
  Admin: {
    name: 'Verifications-Admin',
    permissions: VerificationsAdminPermissions,
  },
  ClientAdmin: {
    name: 'Verifications-Client-Admin',
    permissions: VerificationsClientAdminPermissions,
  },
  ClientUser: {
    name: 'Verifications-Client-User',
    permissions: VerificationsClientUserPermissions,
  },
} as const;
